import React from 'react'
import {
  TypeComponentCtaButton,
  TypeComponentDynamic,
  TypeVariationContainerAuthAndDeviceTypeCta,
} from '../../../lib/types'
import { isTypeComponentDynamic } from '../../../lib/types/content-types'
import { useGetAuthAndDeviceTypeCta } from '../../../lib/hooks/auth-and-device-type-cta'
import { CtaButton } from '../cta-button'
import { ContentRenderer } from '../../renderer'

export type AnyCta = TypeComponentCtaButton | TypeComponentDynamic | TypeVariationContainerAuthAndDeviceTypeCta

interface CtaRendererProps {
  cta: AnyCta
  additionalProps?: Omit<React.ComponentProps<typeof CtaButton>, 'structure'>
}

export const CtaRenderer: React.FC<CtaRendererProps> = ({ cta, additionalProps }) => {
  const { getAuthAndDeviceTypeCta } = useGetAuthAndDeviceTypeCta()

  if (isTypeComponentDynamic(cta)) {
    return <ContentRenderer structure={cta} />
  }

  return <CtaButton structure={getAuthAndDeviceTypeCta(cta)} {...additionalProps} />
}
